import React from "react";
import CustomIcon from "components/CustomIcon";
import Image from "next/image";

export const ReverseOrderWarning: React.FC<{ sectionName: string }> = ({
  sectionName,
}) => {
  return (
    <div className="relative mx-1 flex flex-col gap-[10px] rounded-xl bg-[#40340417] px-[15px] py-[10px] lg:gap-[16px] lg:px-[20px] lg:py-[14px]">
      <div className="absolute left-4 top-[-16px] flex items-center gap-2 rounded-xl bg-white px-4 py-2 font-bold text-black shadow-md lg:left-8 lg:px-6">
        <Image
          src="/icons/score-check/reverseOrder.svg"
          height={24}
          width={24}
          alt="icon"
          className="h-4 w-4 lg:h-5 lg:w-5"
        />
        <span className="text-sm font-bold lg:text-base xl:text-lg">
          {sectionName} in Reverse Order
        </span>
      </div>

      <ul className="mt-4 flex list-disc flex-col items-center px-[3px] marker:text-base marker:text-[#92C5FF] sm:px-[5px] sm:marker:text-lg md:mt-3 lg:marker:text-2xl">
        <div className="relative h-32 w-32 lg:h-40 lg:w-40 mx-auto">
          <Image
            src="/assets/resumeScore/Reverse.png"
            alt="Reverse order illustration"
            fill
            className="object-contain"
          />
        </div>
        <li className="ml-[6px] flex items-center text-center gap-2 text-xs font-medium text-[#B94444] md:text-base lg:ml-[6px] lg:gap-4 lg:text-base xl:text-lg ">
          {/* <div className="h-auto w-auto">
            <CustomIcon iconName="cross" className="h-3 w-3 lg:h-4 lg:w-4" />
          </div> */}
          The newest {sectionName} should be prioritized more and be at top
        </li>
      </ul>
    </div>
  );
};
